module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/partners-01-2646de7bd9e6b8b5aa888515b0a4135d.png";